module.exports = __webpack_public_path__ + "static/img/南京银行.485a5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/南京银行.png
// module id = 1tJa
// module chunks = 18